import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User, ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from '../../hooks/use-toast';
import { adminAPI } from '../../services/api';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      toast({ title: "Missing Fields", description: "Please enter both username and password.", variant: "destructive" });
      return;
    }

    setLoading(true);
    try {
      const result = await adminAPI.login(username, password);
      localStorage.setItem('admin_token', result.access_token);
      toast({ title: "Login Successful", description: "Welcome to JIT Admin Dashboard" });
      navigate('/admin/dashboard');
    } catch (error) {
      toast({ title: "Login Failed", description: error.response?.data?.detail || "Invalid credentials", variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#D62828] to-[#A01E1E] flex items-center justify-center p-4">
      <button onClick={() => navigate('/')} className="absolute top-6 left-6 flex items-center gap-2 text-white hover:text-gray-200 transition-colors" data-testid="admin-back-btn">
        <ArrowLeft className="w-5 h-5" />
        <span className="font-medium">Back to Home</span>
      </button>

      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-white mb-2">Admin Dashboard</h1>
          <p className="text-gray-200">JIT Cargo Express Admin Login</p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="username" className="flex items-center gap-2 mb-2">
                <User className="w-4 h-4" /> Username
              </Label>
              <Input id="username" data-testid="admin-username" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Enter username" className="h-12" />
            </div>
            <div>
              <Label htmlFor="password" className="flex items-center gap-2 mb-2">
                <Lock className="w-4 h-4" /> Password
              </Label>
              <Input id="password" data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter password" className="h-12" />
            </div>
            <Button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full bg-[#D62828] hover:bg-[#B01F1F] text-white font-bold h-12 text-base">
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
